/* eslint-disable max-len */
/* eslint-disable newline-per-chained-call */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { ButtonGroup } from '@material-ui/core';

import FilterWrapper from '../filter-wrapper';
import { Button } from '../../../components';

const styles = {
  buttonGroup: {
    paddingTop: '6px',
    marginBottom: '10px',
    width: '100%',
    flexWrap: 'wrap',
  },
  button: {
    flex: '1 1',
    fontSize: '0.6rem',
    overflow: 'hidden',
  },
};

class QuickDateFilter extends Component {
  render() {
    const { setDateRange, selectedLocation } = this.props;

    const virtualDayStart = (selectedLocation && selectedLocation.virtualDayStart != null)
      ? moment.duration(selectedLocation.virtualDayStart) : moment.duration(5, 'hours');

    const currentDay = moment().hour(virtualDayStart.hours()).minute(virtualDayStart.minutes()).startOf('minute');

    const ranges = [
      {
        name: 'Heute',
        range: {
          startDate: currentDay.unix(),
          endDate: currentDay.clone().add(1, 'day').unix(),
        },
      },
      {
        name: 'Gestern',
        range: {
          startDate: currentDay.clone().subtract(1, 'day').unix(),
          endDate: currentDay.unix(),
        },
      },
      {
        name: 'Diese Woche',
        range: {
          startDate: currentDay.clone().startOf('week').hour(virtualDayStart.hours()).minute(virtualDayStart.minutes()).unix(),
          endDate: currentDay.clone().add(1, 'day').unix(),
        },
      },
      {
        name: 'Letzte 7 Tage',
        range: {
          startDate: currentDay.clone().subtract(6, 'day').unix(),
          endDate: currentDay.clone().add(1, 'day').unix(),
        },
      },
      {
        name: 'Dieses Monat',
        range: {
          startDate: currentDay.clone().startOf('month').hour(virtualDayStart.hours()).minute(virtualDayStart.minutes()).unix(),
          endDate: currentDay.clone().add(1, 'day').unix(),
        },
      },
      {
        name: 'Letztes Monat',
        range: {
          startDate: currentDay.clone().startOf('month').subtract(1, 'month').hour(virtualDayStart.hours()).minute(virtualDayStart.minutes()).unix(),
          endDate: currentDay.clone().startOf('month').hour(virtualDayStart.hours()).minute(virtualDayStart.minutes()).unix(),
        },
      },
    ];

    return (
      <FilterWrapper title="Schnellwahl" height={1}>
        <ButtonGroup size="small" style={styles.buttonGroup}>
          {ranges.map(range => <Button key={range.name} onClick={() => setDateRange(range.range)} style={styles.button}>{range.name}</Button>)}
        </ButtonGroup>
      </FilterWrapper>
    );
  }
}

QuickDateFilter.propTypes = {  
  setDateRange: PropTypes.func,
  selectedLocation: PropTypes.object,
};

QuickDateFilter.defaultProps = {  
  setDateRange: () => {},
  selectedLocation: null,
};

export default QuickDateFilter;
